import { PriorityBadge } from 'domain/recruiting/recruitingBoard/shared';
import React from 'react';
import { BadgeField, TextField } from 'framework/ui/field';
import { TextInput, useFormShowContext } from 'framework/form';
import { useShowContext } from 'framework/show';
import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import OfficeAndAccommodationIcons from './OfficeAndAccommodationIcons';
import VacancyGroupStatusBadge from '../vacancyGroup/shared/badge/VacancyGroupStatusBadge';
import { INIT_COMPETENCY_LEVEL } from 'domain/shared/newVacancy';

interface ShowSectionTitleProps {
  actions?: React.ReactNode;
}

const VacancyGroupSectionTitle: React.FC<ShowSectionTitleProps> = ({ actions }) => {
  const { isEditMode } = useFormShowContext();
  const { data, setData = () => {} } = useShowContext();
  const { technology, specialization, details: { accommodations = [], competencyLevel } = {} } = data.getData() || {};

  return (
    <Box sx={{ width: '100%' }}>
      <Box display="flex" alignItems="center" gap={1} sx={{ width: '100%' }}>
        <Typography variant="h4" mb={0.6}>
          {competencyLevel && competencyLevel !== INIT_COMPETENCY_LEVEL.N_A ? `${competencyLevel} ` : ''}{' '}
          {specialization} {technology ? `(${technology})` : ''}
        </Typography>

        <BadgeField
          style={{ marginRight: '20px', display: 'flex' }}
          badges={[
            <PriorityBadge
              idSource="id"
              prioritySource="priority"
              onChange={response => {
                setData({
                  ...data,
                  data: { ...data, priority: response.priority },
                  ...response,
                });
              }}
            />,
          ]}
        />

        <OfficeAndAccommodationIcons accommodations={accommodations} registrations={[]} />

        <Box display="flex" justifyContent="flex-end" alignItems="center" flexGrow={1}>
          <BadgeField width={100} badges={[<VacancyGroupStatusBadge />]} />
          {actions}
        </Box>
      </Box>
      <Grid size={{ xs: 12, sm: 4 }}>
        {isEditMode ? (
          <Tooltip title="Specific Note" placement="left">
            <TextInput source="specificNote" label="" className="small-input" tooltip="Specific Note" />
          </Tooltip>
        ) : (
          <Typography variant="caption" color="textSecondary">
            <TextField source="specificNote" label="" />
          </Typography>
        )}
      </Grid>
    </Box>
  );
};

export default VacancyGroupSectionTitle;
